import { Observable } from 'rxjs'
import { Effect, Actions } from '@ngrx/effects'
import { Injectable } from '@angular/core'
import { App } from 'ionic-angular'
import { UIAction, ActionCreator } from '../../../../services/action.service'
import { ViewModel } from '../../../../view-model'
import { apiCalls } from './plncmm10000sc00-00.api-call.page'
    
import * as ENV from '../../../../environment'

/**
 * Dashboardページアクション定義
 * @author nabla2.metamodel.generator
 */
@Injectable()
export class Plncmm10000sc0000PageEffects {

  /** 画面名 */
  pageName:string = 'plncmm10000sc00-00'

  /** 機能名 */
  featureName:string = 'cmnfnc-base'

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移コントローラ
   *  
   */
  constructor(
    public action$: Actions,
    public app: App,
    public actionCreator: ActionCreator,
  ) {
  }

  /**
   * ページ内アクション定義
   */
  @Effect() effect():Observable<UIAction> {
    return this.epic(<Observable<any>>this.action$)
  }

  private epic = (action$:Observable<UIAction>):Observable<UIAction> => {
  return action$
  .flatMap((action:UIAction) => {
    switch (action.type) {
      case `cmnfnc-base/plncmm10000sc00-00/画面が表示されたとき 【selectedDashboardMenu】の内容が直近のセッションストレージ上のスナップショットと異なれば`:
        return [
          this.actionCreator.resetViewModelToLatestSnapshotOnSessionStorage(
            'cmnfnc_base.selected_dashboard_menu',
            action.event,
            `【selectedDashboardMenu】を直近のセッションストレージ上のスナップショットの状態に戻す`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/画面が表示されたとき`:
        return [
          this.actionCreator.updateViewModelWithUrlParameter(
            'cmnfnc_base.show_confirm_dialog',
            (viewModel:ViewModel) => ('showConfirmDialog'),
            action.event,
            `【showConfirmDialog】にURLパラメータ【"showConfirmDialog"】を設定する`,
          ),
          this.actionCreator.updateViewModelWithUserId(
            'cmnfnc_base.user.id',
            action.event,
            `【user.id】にユーザIDを設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/画面が表示されたとき ログイン状態であれば`:
        return [
          this.actionCreator.updateViewModelWithBuCd(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】に事業コードを設定する`,
          ),
          this.actionCreator.callApi(
            apiCalls['Authorization User Blng Business Unit Info'],
            action.event,
            `【Authorization User Blng Business Unit Info】を呼び出す`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【Authorization User Blng Business Unit Info】が正常応答したとき`:
        return [
          this.actionCreator.applyApiResult(
            apiCalls['Authorization User Blng Business Unit Info'],
            action.event,
            `【Authorization User Blng Business Unit Info】の結果を画面に反映する`,
          ),
          this.actionCreator.setAuthAimUserInfo(
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.business.business_unit_pulldown_list),
            action.event,
            `【business.businessUnitPulldownList】を認可サービスに登録する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuNotification】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('notification'),
            action.event,
            `【selectedDashboardMenu】に【"notification"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuNotificationUpload】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('notification_upload'),
            action.event,
            `【selectedDashboardMenu】に【"notification_upload"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuOfficialPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('official_plan'),
            action.event,
            `【selectedDashboardMenu】に【"official_plan"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuSalesInventoryPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('sales_inventory_plan'),
            action.event,
            `【selectedDashboardMenu】に【"sales_inventory_plan"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuProduction】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('production'),
            action.event,
            `【selectedDashboardMenu】に【"production"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuOrder】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('order'),
            action.event,
            `【selectedDashboardMenu】に【"order"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuRawMaterialPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('raw_material_plan'),
            action.event,
            `【selectedDashboardMenu】に【"raw_material_plan"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuInventoryControl】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('inventory_control'),
            action.event,
            `【selectedDashboardMenu】に【"inventory_control"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuCommonMaster】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('common_master'),
            action.event,
            `【selectedDashboardMenu】に【"common_master"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuMaterialManagement】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('material_management'),
            action.event,
            `【selectedDashboardMenu】に【"material_management"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuAimAllocation】を押したとき`:
        return [
          this.actionCreator.reacquireAimAuthInfo(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】を用いAIM用画面項目認可情報を取得する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('aim_allocation'),
            action.event,
            `【selectedDashboardMenu】に【"aim_allocation"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuAimLogistics】を押したとき`:
        return [
          this.actionCreator.reacquireAimAuthInfo(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】を用いAIM用画面項目認可情報を取得する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('aim_logistics'),
            action.event,
            `【selectedDashboardMenu】に【"aim_logistics"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuAimItemPrice】を押したとき`:
        return [
          this.actionCreator.reacquireAimAuthInfo(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】を用いAIM用画面項目認可情報を取得する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('aim_item_price'),
            action.event,
            `【selectedDashboardMenu】に【"aim_item_price"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuAimInventoryAccuracy】を押したとき`:
        return [
          this.actionCreator.reacquireAimAuthInfo(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】を用いAIM用画面項目認可情報を取得する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('aim_inventory_accuracy'),
            action.event,
            `【selectedDashboardMenu】に【"aim_inventory_accuracy"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuAimMasterDownload】を押したとき`:
        return [
          this.actionCreator.reacquireAimAuthInfo(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】を用いAIM用画面項目認可情報を取得する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('aim_master_download'),
            action.event,
            `【selectedDashboardMenu】に【"aim_master_download"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.DashboardMenuAimAdmin】を押したとき`:
        return [
          this.actionCreator.reacquireAimAuthInfo(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】を用いAIM用画面項目認可情報を取得する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu',
            (viewModel:ViewModel) => ('aim_admin'),
            action.event,
            `【selectedDashboardMenu】に【"aim_admin"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき`:
        return [
          this.actionCreator.takeSnapshotOfViewModelOnSessionStorage(
            'cmnfnc_base.selected_dashboard_menu',
            action.event,
            `【selectedDashboardMenu】のスナップショットをセッションストレージ上に取得する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu),
            action.event,
            `【dashboardRedirectHost】に【selectedDashboardMenu】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"notification_upload"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_notification_upload),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuNotificationUpload】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"official_plan"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_official_plan),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuOfficialPlan】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"sales_inventory_plan"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_sales_inventory_plan),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuSalesInventoryPlan】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"production"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_production),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuProduction】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"order"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_order),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuOrder】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"raw_material_plan"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_rawMaterialPlan),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuRawMaterialPlan】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"inventory_control"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_inventoryControl),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuInventoryControl】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"common_master"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_common_master),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuCommonMaster】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"material_management"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_materialManagement),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuMaterialManagement】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_allocation"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_aim_allocation),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuAimAllocation】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_logistics"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_aim_logistics),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuAimLogistics】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_item_price"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_aim_item_price),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuAimItemPrice】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_inventory_accuracy"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_aim_inventory_accuracy),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuAimInventoryAccuracy】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_master_download"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_aim_master_download),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuAimMasterDownload】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_admin"】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_menu_title',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_menu.dashboard_menu_aim_admin),
            action.event,
            `【selectedDashboardMenuTitle】に【dashboardMenu.dashboardMenuAimAdmin】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsNotificationUploadForm.DashboardContentsNotificationUpload】を押したとき`:
        return [
          this.actionCreator.callApi(
            apiCalls['Notification Upload API'],
            action.event,
            `【Notification Upload API】を呼び出す`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【Notification Upload API】が正常応答したとき`:
        return [
          this.actionCreator.showToast(
            (viewModel:ViewModel) => ('Success to upload'),
            (viewModel:ViewModel) => ('complete'),
            action.event,
            `【'Success to upload'】をトースト表示する【'complete'】`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/APIがユーザエラーで応答したとき`:
        return [
          this.actionCreator.showApiUserError(
    
            action.event,
            `ユーザエラーの内容を画面に反映する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】であれば`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => (''),
            action.event,
            `【selectedDashboardUrl】に【""】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu),
            action.event,
            `【dashboardRedirectHost】に【selectedDashboardMenu】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】であれば、かつ【selectedDashboardUrl】が【""】でなければ`:
        return [
          this.actionCreator.showToastMessageWithParam(
            (viewModel:ViewModel) => ('E_BLU_42510'),
            (viewModel:ViewModel) => (['GBU Code']),
            (viewModel:ViewModel) => ('alert'),
            action.event,
            `【'E_BLU_42510'】のメッセージに【['GBU Code']】を埋め込んでトースト表示する【'alert'】`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】でなければ`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_url',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_url),
            action.event,
            `【dashboardRedirectUrl】に【selectedDashboardUrl】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【dashboardRedirectUrl】が変わったとき 【showConfirmDialog】が【"true"】であれば`:
        return [
          this.actionCreator.showConfirmDialogMessage(
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.confirm_dialog_option),
            (viewModel:ViewModel) => ('s'),
            action.event,
            `メッセージID指定でオプション【confirmDialogOption】の確認ダイアログを表示する【's'】`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedAriakeInventoryManagementDashboardUrl】が変わったとき 【businessUnitSelected】が空であれば`:
        return [
          this.actionCreator.showToastMessageWithParam(
            (viewModel:ViewModel) => ('E_BLU_42510'),
            (viewModel:ViewModel) => (['BU Code']),
            (viewModel:ViewModel) => ('alert'),
            action.event,
            `【'E_BLU_42510'】のメッセージに【['BU Code']】を埋め込んでトースト表示する【'alert'】`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【selectedAriakeInventoryManagementDashboardUrl】が変わったとき 【businessUnitSelected】が空でなければ`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_url',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_ariake_inventory_management_dashboard_url),
            action.event,
            `【dashboardRedirectUrl】に【selectedAriakeInventoryManagementDashboardUrl】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('ariake_inventory_management/' +viewModel.cmnfnc_base.business.business_unit_pulldown_list.find(i=>i['value'] ===viewModel.cmnfnc_base.business_unit_selected)['tmzne']),
            action.event,
            `【dashboardRedirectHost】に【"ariake_inventory_management/" + business.businessUnitPulldownList.find(i=>i['value'] === businessUnitSelected )['tmzne']】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/確認ダイアログ【"dashboard_confirm_ok"】ボタンを押したとき`:
        return [
          this.actionCreator.redirectToPage(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_redirect_url),
            action.event,
            `【dashboardRedirectHost】【dashboardRedirectUrl】にリダイレクトする`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu),
            action.event,
            `【dashboardRedirectHost】に【selectedDashboardMenu】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/確認ダイアログ【"dashboard_confirm_cancel"】ボタンを押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu),
            action.event,
            `【dashboardRedirectHost】に【selectedDashboardMenu】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【dashboardRedirectUrl】が変わったとき 値【ariakeInventoryManagementDashboardMenuList.indexOf(selectedDashboardMenu)>= 0】が【true】でなければ`:
        return [
          this.actionCreator.redirectToPage(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_redirect_url),
            action.event,
            `【dashboardRedirectHost】【dashboardRedirectUrl】にリダイレクトする`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu),
            action.event,
            `【dashboardRedirectHost】に【selectedDashboardMenu】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【dashboardRedirectUrl】が変わったとき 値【ariakeInventoryManagementDashboardMenuList.indexOf(selectedDashboardMenu)>= 0 && dashboardRedirectUrl !== ""】が【true】であれば`:
        return [
          this.actionCreator.callApi(
            apiCalls['Online Block Status'],
            action.event,
            `【Online Block Status】を呼び出す`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【Online Block Status】が正常応答したとき`:
        return [
          this.actionCreator.applyApiResult(
            apiCalls['Online Block Status'],
            action.event,
            `【Online Block Status】の結果を画面に反映する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【Online Block Status】が正常応答したとき 【onlineBlockStatusFlg】が【"Y"】であれば`:
        return [
          this.actionCreator.redirectToPage(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_redirect_url),
            action.event,
            `【dashboardRedirectHost】【dashboardRedirectUrl】にリダイレクトする`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【Online Block Status】が正常応答したとき 【onlineBlockStatusFlg】が【"N"】であれば`:
        return [
          this.actionCreator.showToastMessage(
            (viewModel:ViewModel) => ('E_BLU_44002'),
            (viewModel:ViewModel) => ('alert'),
            action.event,
            `【'E_BLU_44002'】のメッセージをトースト表示する【'alert'】`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => (''),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【""】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.online_block_status_flg',
            (viewModel:ViewModel) => (''),
            action.event,
            `【onlineBlockStatusFlg】に【""】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.userRolePulldown】を変更したとき 【userRoleSelected】が【""】でなければ`:
        return [
          this.actionCreator.reacquireAuthInfo(
            'cmnfnc_base.user_role_selected',
            action.event,
            `【userRoleSelected】を用い認可情報を取得する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardMenuForm.businessUnitPulldown】を変更したとき 【businessUnitSelected】が【""】でなければ`:
        return [
          this.actionCreator.reacquireAimAuthInfo(
            'cmnfnc_base.business_unit_selected',
            action.event,
            `【businessUnitSelected】を用いAIM用画面項目認可情報を取得する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalDirectionByDept】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp70800sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp70800sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalOfficialPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalItemSampleLink】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50100sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50100sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanPreviousYearSumMappingLYComparison】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60100sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60100sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalItemRelocation】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50100sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50100sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanSeasonalCoreCategoryMaster】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50700sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50700sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanSeasonalCoreCategoryRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50710sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50710sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanSeasonalCoreCategorySummaryGlobalComparison】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50720sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50720sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanLocalOfficialPlanSalesAmountGlobalComparisonByCoreCategory】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50400sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50400sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomLeft.officialPlanLocalOfficialPlanSalesAmountGlobalComparisonDeptSubCategory1】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50500sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50500sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanLocalOfficialPlanSalesAmountGlobalComparisonByPjItem】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp50410sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp50410sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopRight.OfficialPlanLocalOfficialPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPreviousYearSumMappingCarryover】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60100sc02_03'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60100sc02_03"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPriceCOGSSimulation】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/PLNOFP70200SC01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/PLNOFP70200SC01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPricelineRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp70700sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp70700sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanLocalOfficialPlanSalesAmountByCoreCategory】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60400sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60400sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanLocalOfficialPlanVerificationReportByCoreCategoryByPlanningSum】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60410sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60410sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanOfficialPlanRawdataExport】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60400sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60400sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.RegionalOfficialPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60150sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60150sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.RegionalNumOfStoreMaster】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60160sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60160sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.RegionalSeasonDeptBasedBusinessPlanInboundProcess】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60170sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60170sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.RegionalPreviousSeasonResultsRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60180sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60180sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOfficialPlanFormBottomRight.RegionalOfficialPlanOfficialPlanRawdataExport】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60190sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60190sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanSalesInventoryPlanningBySalesSum】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('salesinv/plnsip20100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"salesinv/plnsip20100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanPromotionMasterSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('salesinv/plnsip20100sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"salesinv/plnsip20100sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanEndOfSeasonInventory】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('salesinv/plnsip20100sc04_01'),
            action.event,
            `【selectedDashboardUrl】に【"salesinv/plnsip20100sc04_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanWeeklyPrintableForm】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('salesinv/plnsip20400rp10_01'),
            action.event,
            `【selectedDashboardUrl】に【"salesinv/plnsip20400rp10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanCheckRepSkuSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('salesinv/plnsip70400rp03_01'),
            action.event,
            `【selectedDashboardUrl】に【"salesinv/plnsip70400rp03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanCheckSeasonEndTotalInventoryList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('salesinv/plnsip70400rp04_01'),
            action.event,
            `【selectedDashboardUrl】に【"salesinv/plnsip70400rp04_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsSalesInventoryPlanForm2.DashboardMenuSalesInventoryPlanSalesInventoryPlanningBySku】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('salesinv/plnsip70100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"salesinv/plnsip70100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.ProductionPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20200sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20200sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.ProductionCapacityGraph】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20110sc06_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20110sc06_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.ProductionFactoryBasedPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20110sc05_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20110sc05_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.ProductionPlanSimulation】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20200sc03_03'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20200sc03_03"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.productionPlanPublishmentForFactory】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20200sc05_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20200sc05_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.productionPlanFactoryForCapacityGraph】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20110sc08_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20110sc08_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.productionPlanFactoryCapacityPlan】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20700sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20700sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm2.ProductionItemProductionCategoryLinkSewingFabric】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20110sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20110sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.productionPlanStopGoFileUpload】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20800sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20800sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.productionPlanDLSheet】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20810sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20810sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.productionCapacityGraphOutput】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20120sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20120sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm1.representativeManagementFactorySetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20130sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20130sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm2.ProductionItemProductionCategoryLinkFabric】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20110sc03_03'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20110sc03_03"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm2.ProductionProcessBasedLeadtime】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20110sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20110sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm2.ProductionOrderConditionRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20110sc02_02'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20110sc02_02"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm4.productionPlanMdView】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20900sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20900sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm4.productionPlanPrdFctView】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20900sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20900sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm4.productionPlanUnexRawdata】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20900sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20900sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm5.ProductionPlanRawdataExport】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('prodplncapamng/plnprp20200sc04_01'),
            action.event,
            `【selectedDashboardUrl】に【"prodplncapamng/plnprp20200sc04_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsProductionForm5.DetectionOfOrderProgress】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('materialmng/plnrmp20300sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"materialmng/plnrmp20300sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm1.ProductionGlobalColorSizeOrderSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('official_plan'),
            action.event,
            `【dashboardRedirectHost】に【"official_plan"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/PLNOFP80100SC01_02'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/PLNOFP80100SC01_02"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm1.ProductionReferenceItemMapping】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('official_plan'),
            action.event,
            `【dashboardRedirectHost】に【"official_plan"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp90100sc04_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp90100sc04_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm2.ProductionLocalColorSizeOrderSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('official_plan'),
            action.event,
            `【dashboardRedirectHost】に【"official_plan"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp90100sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp90100sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm2.ProductionOrderPlanList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnprp20300sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnprp20300sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm2.ProductionBDSheet】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe10100sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe10100sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm3.ProductionOrderExecutionList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe30100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe30100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm3.ProductionOrderApprovalList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe20200sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe20200sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm3.ProductionOrderApprovalListForMobile】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe20200sc01_02'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe20200sc01_02"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionCostSequenceNoRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('common'),
            action.event,
            `【dashboardRedirectHost】に【"common"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plncmm10100sc01_001'),
            action.event,
            `【selectedDashboardUrl】に【"base/plncmm10100sc01_001"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionItemAttributeList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('common'),
            action.event,
            `【dashboardRedirectHost】に【"common"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plncmm10100sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plncmm10100sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionPackingInstruction】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('common'),
            action.event,
            `【dashboardRedirectHost】に【"common"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plncmm40100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plncmm40100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionWHDistributionRatioRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnicl90100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnicl90100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionThresholdRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe30200sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe30200sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionTransferItemRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('common'),
            action.event,
            `【dashboardRedirectHost】に【"common"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plncmm10120SC01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plncmm10120SC01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionDefaultPackingQuantitySetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('official_plan'),
            action.event,
            `【dashboardRedirectHost】に【"official_plan"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60100sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60100sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionDoChange】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnicl100200sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnicl100200sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionDoAllocation】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnicl100202sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnicl100202sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionExceptionalItemRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe40100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe40100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsOrderForm4.ProductionNAssortRatioRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe30300sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe30300sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsInventoryControlForm.InventoryControlStoreParameterSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('strplncntl/plnicl20100sc01_001'),
            action.event,
            `【selectedDashboardUrl】に【"strplncntl/plnicl20100sc01_001"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsInventoryControlForm.InventoryControlSalesSumParameterSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('strplncntl/plnicl20100sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"strplncntl/plnicl20100sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsCommonMasterForm.CommonMasterSeasonRateMaster】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('common'),
            action.event,
            `【dashboardRedirectHost】に【"common"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plncmm50100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plncmm50100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsCommonMasterForm.CommonMasterNumberOfStoreMaster】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.dashboard_redirect_host',
            (viewModel:ViewModel) => ('official_plan'),
            action.event,
            `【dashboardRedirectHost】に【"official_plan"】を設定する`,
          ),
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('ofclpln/plnofp60700sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"ofclpln/plnofp60700sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormTopLeft.MaterialDiversionRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('materialmng/plnrmp30100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"materialmng/plnrmp30100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomLeft.OrderExecutionList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe30100sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe30100sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomLeft.OrderApprovalList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe20200sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe20200sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomLeft.OrderApprovalListForMobile】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe20200sc01_02'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe20200sc01_02"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomLeft.BoForEarlyMaterialOrder】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnrmp20100sc01_004'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnrmp20100sc01_004"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomLeft.BoForReservedMaterialOrder】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnrmp20100sc01_005'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnrmp20100sc01_005"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomLeft.BdForReservedMaterialOrder】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('base/plnpoe10100sc01_08'),
            action.event,
            `【selectedDashboardUrl】に【"base/plnpoe10100sc01_08"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomRight.RawdataExportForMaterialRemainsConfirmation】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('materialmng/plnrmp30300sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"materialmng/plnrmp30300sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormBottomRight.MaterialPlanAndOrder】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('materialmng/plnrmp20300sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"materialmng/plnrmp20300sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormTopRight.AutomaticAssignmentExclusionFRMaterialRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('materialmng/plnrmp20200sc02_01'),
            action.event,
            `【selectedDashboardUrl】に【"materialmng/plnrmp20200sc02_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormTopRight.OrderProcessPatternMasterRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('materialmng/plnrmp20200sc01_01'),
            action.event,
            `【selectedDashboardUrl】に【"materialmng/plnrmp20200sc01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsMatFormTopRight.MasterForMaterialPlanAndOrder】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_dashboard_url',
            (viewModel:ViewModel) => ('materialmng/plnrmp20200sc03_01'),
            action.event,
            `【selectedDashboardUrl】に【"materialmng/plnrmp20200sc03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimInventoryCockpitForm.AimControlCockpit】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims42101D30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims42101D30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimReportForm.AimReferenceForTransfer】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40708d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40708d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimConfirmationOfExcelUploadOfDemandForecast】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31502d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31502d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimWeeklyStockPlanbyLineupType】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31201d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31201d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimOrderLimitSettingByStyle】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31101d60_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31101d60_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimConfirmationOfExcelUploadOfStoreAlocGthrUpperLowerLimited】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31101d40_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31101d40_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimOrderLimitSettingByStore】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31101d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31101d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimSettingOfFaceRatio】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims10304d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims10304d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimDownloadOfFaceRatioFile】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims30801d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims30801d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm2.AimConfirmationOfExcelUploadOfDeliveryRatioByDay】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31601d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31601d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm2.AimConfirmationOfExcelUploadOfItemInformation】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims30203d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims30203d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm2.AimInformationRegistration】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims30203d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims30203d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm2.AimSettingOfLineTypeByStore】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31201d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31201d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm2.AimWeeklyStandartStockUploadBySku】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims31701d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims31701d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSPSSettingForm1.AimSettingOfFaceRatioNew】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims10304d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims10304d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingByStyle】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40701dj0_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40701dj0_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingForEcByStyle】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40701dj1_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40701dj1_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingByStore】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('slsinvpln/ims30903d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"slsinvpln/ims30903d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm1.AimReplenishmentDateSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40701dp0_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40701dp0_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm1.AimProhibitedDeliveryDateSettingByStoreAndGdept】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40703d40_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40703d40_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm2.AimReplenishmentTargetSettingBySku】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40701dt0_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40701dt0_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm2.AimSettingOfLayawayStockStatusShift】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims50402d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims50402d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm2.AimDownloadOfLayawayStockStatusFile】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims50402d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims50402d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm2.AimStoreAllocationPrioritySetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40502d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40502d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreOrderForm2.AimExcelDownloadOfReplenishmentControl】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40703d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40703d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSCOrderForm1.AimScOrderHome】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40701d40_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40701d40_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSCOrderForm1.AimConfirmationOfExcelUploadingOfScOrderByItem】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims50104d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims50104d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSCOrderForm1.AimConfirmationOfExcelUploadingOfScOrderByAssortSku】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims50104d60_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims50104d60_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSCOrderForm2.AimUrgentRequestForShipment】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40701dr0_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40701dr0_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSCOrderForm2.AimStoreGroupMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40501d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40501d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSCOrderForm2.AimSettingOfTemporaryFaceRatio】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40701d50_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40701d50_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimTransferConsolidationForm.AimSearchForTransferOfAllItemsAndReturnToVender】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41101d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41101d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimTransferConsolidationForm.AimAreaManagerStoreToStoreDeliveryOrder】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims60001d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims60001d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimTransferConsolidationForm.AimSettingOfTransferToConcentrateStock】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims30603d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims30603d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreSettingForm.AimLogisticsTerritoryMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims11301d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims11301d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreSettingForm.AimSettingOfPriorityAllocationByStore】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims30501d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims30501d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreSettingForm.AimLogisticsMasterMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims42801d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims42801d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimItemSettingForm.AimWarehouseByItemCollectiveSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims30501d11_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims30501d11_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimItemSettingForm.AimSettingOfWarehouseByItem】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims30501d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims30501d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimTransferForm.AimTransferSearchWindow】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40401d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40401d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimTransferForm.AimTransferInstructionWarehouseExcelUpload】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims40401d40_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims40401d40_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimMinimumDeliveryQuantityForm.AimSettingOfMinimumQtyByGdeptClass】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims30503d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims30503d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimWhWhMasterForm.AimWh2WhOrderRegionMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41701d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41701d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimWhWhMasterForm.AimWh2WhLogisticsMasterMaintenanceLowerLimitOfShippable】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41702d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41702d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimWhWhMasterForm.AimWh2WhLogisticsMasterMaintenanceLeadTime】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41702d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41702d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimWhWhMasterForm.AimWh2WhSettingOfCartonVolume】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41704d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41704d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimWhWhOrderForm.AimWh2WhReplenishmentApprovalByGdept】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41809d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41809d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimWhWhOrderForm.AimWh2WhAllocationItemSettingItem】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41705d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41705d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimWhWhOrderForm.AimWh2WhAllocationItemSettingCopySetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41705d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41705d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSumMaintenanceForm.AimSumCodeSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims20901d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims20901d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSumMaintenanceForm.AimRepSkuSetting】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims20901d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims20901d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSumMaintenanceForm.AimAllocationPrioritySettingBySku】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims20901d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims20901d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSumMaintenanceForm.AimUserAttributeMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('sysset/ims60202d50_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"sysset/ims60202d50_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimAssortmaintenanceForm.AimAssortmentMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims10109d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims10109d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPriceChangeForm.AimPriceChangeSearch】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims10401d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims10401d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPriceChangeForm.AimPriceChangeExcelUpload】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims21401d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims21401d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPriceChangeForm.AimPricelineMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims21401d50_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims21401d50_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPromotionForm.AimEventList】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims10501d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims10501d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPromotionForm.AimPromotionExcelUpload】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims21406d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims21406d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPromotionForm.AimPromotionExcelUploadItemAndPrice】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims21406d50_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims21406d50_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimInventoryMaintenanceForm.AimSearchForDeliveryAndShipmentHistory】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims40802d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims40802d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimInventoryMaintenanceForm.AimConfirmationOfExcelUploadingOfShipment】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims40902d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims40902d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimInventoryMaintenanceForm.AimInventoryAdjustmentStockStatusShift】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims42101d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims42101d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimInventoryMaintenanceForm.AimBookTransfer】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims44601d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims44601d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStockTakingForm.AimStockTakeRequestMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims41601d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims41601d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStockTakingForm.AimConfirmationOfExcelUploadingOfStocktakingAdjustment】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims51803d20_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims51803d20_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStockTakingForm.AimExcelOutputOfStocktakingAdjustment】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims51803d40_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims51803d40_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimMasterForm.AimMasterDownload】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('oprtmng/ims80101d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"oprtmng/ims80101d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreMasterForm.AimStoreMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('orgmng/ims10801d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"orgmng/ims10801d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreMasterForm.AimAreaMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('orgmng/gms20701d50_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"orgmng/gms20701d50_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimStoreMasterForm.AimBlockMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('orgmng/gms20701d60_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"orgmng/gms20701d60_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimLogisticsMasterForm.AimWarehouseMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('orgmng/ims12701d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"orgmng/ims12701d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimLogisticsMasterForm.AimOrderRegionMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('orgmng/ims10203d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"orgmng/ims10203d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimLogisticsMasterForm.AimLogisticsCompanyMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims11304d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims11304d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimLogisticsMasterForm.AimReferenceNumberMasterMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invcntl/ims42901d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invcntl/ims42901d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSMasterForm.AimTenderType】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('cmnmst/ims12201d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"cmnmst/ims12201d30_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSMasterForm.AimMaintenanceOfCreditCompanyInfo】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('cmnmst/ims11401d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"cmnmst/ims11401d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSMasterForm.AimCodeMaintenanceOfNonItemSales】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('cmnmst/ims13001d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"cmnmst/ims13001d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSDataForm.AimPosDataSearch】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims43901dd0_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims43901dd0_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSDataForm.AimStoreSummaryDataDetail】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims51203d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims51203d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSDataForm.AimReferenceOfBalanceBetweenSalesAndPos】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims43902d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims43902d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSDataForm.AimReferenceOfSalesDataCollection】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims51204d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims51204d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSDataForm.AimSearchForDailyConditionOfStores】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims43901d90_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims43901d90_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimPOSDataForm.AimSearchForChangeHistoryOfPosData】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims43901dh0_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims43901dh0_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSystemControlForm.AimPosDataFileImport】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims43810d01_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims43810d01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSystemControlForm.AimEndOfMonthProcessing】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('invdist/ims43601d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"invdist/ims43601d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSystemControlForm.AimDelayedOnlineBatchManagement】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('sysset/ims60601d01_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"sysset/ims60601d01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSystemControlForm.AimDataDeliveryToStoresOnSystemErrors】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('sysset/ims60301d10_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"sysset/ims60301d10_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSalesTaxVATMaintenanceForm.AimGeocodeHierarchyMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('cmnmst/ims00501d01_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"cmnmst/ims00501d01_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSalesTaxVATMaintenanceForm.AimTaxHierarchy】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('cmnmst/ims00501d03_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"cmnmst/ims00501d03_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSalesTaxVATMaintenanceForm.AimTaxRateView】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('cmnmst/ims00501d05_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"cmnmst/ims00501d05_01"】を設定する`,
          ),
        ]
      case `cmnfnc-base/plncmm10000sc00-00/【DashboardContentsAimSalesTaxVATMaintenanceForm.AimVATItemMaintenance】を押したとき`:
        return [
          this.actionCreator.updateViewModel(
            'cmnfnc_base.selected_ariake_inventory_management_dashboard_url',
            (viewModel:ViewModel) => ('itmmng/ims21801d30_01'),
            action.event,
            `【selectedAriakeInventoryManagementDashboardUrl】に【"itmmng/ims21801d30_01"】を設定する`,
          ),
        ]
      default:
        return []
    }
  })
}
    
}


// WEBPACK FOOTER //
// ./src/features/cmnfnc-base/pages/plncmm10000sc00-00/plncmm10000sc00-00.effects.page.ts